<template>
  <form-section-checkbox
    :title="$t('Engagement_Category_Exclusion_Title')"
    :description="$t('Engagement_Category_Exclusion_Description')"
    v-model="exclusion_enabled"
    :disabled="readOnly"
  >
    <el-row>
      <el-col :span="5">
        <div>
          <div>
            <label style="font-size: 14px; color: #5c6374;">
              {{ $t('Engagement_Category_Exclude_From_All_Categories') }}
            </label>
            <form-item-i-tooltip placement="top-start">
              <template #content>
                {{ $t('Engagement_Category_Exclude_From_All_Categories_info') }}
              </template>
            </form-item-i-tooltip>
          </div>
          <p class="description">
            {{
              $t('Engagement_Category_Exclude_From_All_Categories_description')
            }}
          </p>
        </div>
      </el-col>
      <el-col :span="11">
        <div>
          <rest-form-item prop="global_exclusion">
            <el-switch
              v-model="categoryModel.global_exclusion"
              :disabled="readOnly"
            />
          </rest-form-item>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div class="label-ct">
          <label>
            {{ $t('Engagement_Category_Limit_By_Engagement_Category') }}
          </label>
        </div>
        <div>
          <rest-form-item prop="exclusion_category_ids">
            <el-select
              v-model="categoryModel.exclusion_category_ids"
              multiple
              filterable
              remote
              :remote-method="fetchEngagementCategories"
              clearable
              :loading="loadingEngagmentCategories"
              :disabled="readOnly || !!categoryModel.global_exclusion"
            >
              <el-option
                v-for="item in engagementCategories"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </rest-form-item>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="label-ct">
          <label>{{ $t('Engagement_Category_Limit_By_Time_Frame') }}</label>
        </div>
        <div class="form-ct">
          <rest-form-item prop="exclusion_amount">
            <el-input
              v-model="categoryModel.exclusion_amount"
              style="width: 90px"
              :disabled="readOnly"
              @input="validateExclusionAmount"
            />
          </rest-form-item>
          <rest-form-item prop="exclusion_measure">
            <enum-select
              v-model="categoryModel.exclusion_measure"
              :options="categoryCooldownLabels"
              style="width: 150px;"
              :disabled="readOnly"
              @input="validateExclusionAmount"
            />
          </rest-form-item>
        </div>
      </el-col>
    </el-row>
  </form-section-checkbox>
</template>

<script>
import FormSectionCheckbox from '@/common/components/form/FormSectionCheckbox'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { categoryCooldownLabels } from '@/common/enum/CategoryEnums'
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import EnumSelect from '@/common/components/form/EnumSelect.vue'
import FormItemITooltip from '@/common/components/form/FormItemITooltip.vue'

export default {
  name: 'EngagementCategoriesExclusionSection',
  components: {
    FormItemITooltip,
    EnumSelect,
    RestFormItem,
    FormSectionCheckbox
  },
  props: {
    categoryModel: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      categoryCooldownLabels,
      loadingEngagmentCategories: false,
      engagementCategories: [],
      exclusion_enabled: 0
    }
  },

  mounted() {
    this.fetchEngagementCategories()
    if (
      (this.categoryModel.global_exclusion ||
        this.categoryModel.exclusion_category_ids.length) &&
      this.categoryModel.exclusion_amount &&
      this.categoryModel.exclusion_measure
    ) {
      this.exclusion_enabled = 1
      this.$emit('updateExclusionEnabled', this.exclusion_enabled)
    }
  },

  methods: {
    fetchEngagementCategories(query) {
      this.loadingEngagmentCategories = true
      let params = { sort: 'title' }
      if (query !== null && query !== '') {
        params.title = query
      }
      let endpoint = projectEndpoint({
        method: 'get',
        url: 'categories',
        params: params
      })

      RestApi(endpoint)
        .then(({ data }) => {
          this.engagementCategories = data
          this.loadingEngagmentCategories = false
        })
        .catch(error => {
          this.loadingEngagmentCategories = false
          this.$message({
            message: error.message,
            type: error
          })
        })
    },

    validateExclusionAmount() {
      this.$emit('validateExclusionAmount')
    }
  },

  watch: {
    'categoryModel.global_exclusion': {
      handler(value) {
        if (value) {
          this.categoryModel.exclusion_category_ids = []
        }
      }
    },

    exclusion_enabled: function(value) {
      this.$emit('updateExclusionEnabled', value)
      if (!value) {
        this.$emit('clearExclusionModel')
      }
    }
  }
}
</script>

<style scoped>
>>> .el-row {
  margin-bottom: 32px;
}

>>> .el-row:last-child {
  margin-bottom: 0px;
}

>>> .content .content {
  padding-left: 32px;
  padding-top: 32px;
}

>>> .el-form-item__error {
  width: auto;
}

.label-ct {
  display: inline-block;
  height: 30px;
  font-size: 14px;
  color: #5c6374;
}

.form-ct {
  display: flex;
  column-gap: 20px;
}

.description {
  color: #7e8596;
  font-size: 12px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/EngagementCategoriesExclusionSection.vue